<div class="root" (dblclick)="reset()">
    @for (line of output; track line) {
        <div [ngClass]="line.component">
            [{{ line.component.padEnd(16, "&nbsp;") }}] ({{
                line.subscription.padEnd(16, "&nbsp;")
            }})
            {{ line.value | json }}
        </div>
    }
</div>
